export default {
  currencySymbol: 'L'
}
